export const reduceArrayOfObjectsToObject = (array) => array.reduce((obj, item) => {
    return {
        ...obj,
        ...item,
    };
}, {});
